// extracted by mini-css-extract-plugin
export default {"logo":"insurance-logo_logo__G9grh"};